import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import FeatureContainer from "../features"
import confetti from "../../images/confetti.svg"

const AdminFeatures = () => {
  const data = useStaticQuery(graphql`
    {
      yaml: contentYaml(header: { slug: { eq: "/index" } }) {
        content {
          adminFeatures {
            subtitle
            title
            secondList {
              image
              title
            }
            featureList {
              description
              image
              title
              slug
            }
          }
        }
      }
      images: allFile(filter: { relativePath: { regex: "/feature-icons/" } }) {
        nodes {
          image: childImageSharp {
            fixed(height: 60) {
              originalName
              ...GatsbyImageSharpFixed
            }
          }
        }
      }
    }
  `)
  console.log('feat', data.yaml.content.adminFeatures)
  return (
    <FeatureContainer
      data={data.yaml.content.adminFeatures}
      images={data.images}
      premium={true}
      perRow={[2, 2, 5]}
      background={confetti}
    />
  )
}

export default AdminFeatures
